export default {
  en: {
    enterPin: 'Enter the PIN',
    resetPassword: 'Reset the password',
    alertEmailOnly: 'It is only possible to request a password reset if you use an email, otherwise contact your administrator',
    enterEmail: 'Enter your email',
    requestReset: 'Request reset password',
    loginNewPassword: 'Now you can access with the new password',
    checkYourEmail: 'Check your email',
    pinSendYour: 'Was sent an email with a PIN, do not close this page',
    errors: {
      activeReset: 'There is another active password reset request',
      invalidPin: 'Invalid PIN',
    }
  },
  es: {
    enterPin: 'Ingresa el PIN',
    resetPassword: 'Restablecer la contraseña',
    alertEmailOnly: 'Solo es posible solicitar restablecer contraseña si utilizas un email, de lo contrario contacta con tu administrador',
    enterEmail: 'Ingresa tu email',
    requestReset: 'Solicitar restablecer contraseña',
    loginNewPassword: 'Puedes iniciar sesión con tu nueva contraseña',
    checkYourEmail: 'Revise su email',
    pinSendYour: 'Se envió un correo electrónico con un PIN, no cierres esta página',
    errors: {
      activeReset: 'Hay otra solicitud de restablecimiento de contraseña activa',
      invalidPin: 'PIN inválido',
    }
  },
  fr: {
    enterPin: 'Entrez le PIN',
    resetPassword: 'Réinitialiser le mot de passe',
    alertEmailOnly: 'Il est uniquement possible de demander la réinitialisation du mot de passe par email ; sinon, veuillez contacter votre administrateur.',
    enterEmail: 'Entrez votre email',
    requestReset: 'Demander la réinitialisation du mot de passe',
    loginNewPassword: 'Vous pouvez vous connecter avec votre nouveau mot de passe',
    checkYourEmail: 'Vérifiez votre email',
    pinSendYour: 'Un email contenant un PIN a été envoyé, ne fermez pas cette page',
    errors: {
      activeReset: 'Une autre demande de réinitialisation du mot de passe est en cours',
      invalidPin: 'PIN invalide',
    }
}

}
